import Toast from "../../components/Toast";
import Layout from "../../components/Layout";
import styles from "./Main.module.css"
import userData from '../../data/user.json';

export default function Main() {
    const user = userData;

    return (
        <Layout>
            <div className={styles.mainContainer}>
                <div className={styles.avatarWrapper}>
                    <div className={styles.avatar}>
                        <img
                            src="/barkos.png"
                            alt="Avatar"
                        />
                    </div>
                </div>
                <div className={styles.name}>Андрей / Barkos</div>
                <div className={styles.bio}>
                    Ну типа Студент, ну типа Программист
                </div>
            </div>

            <div className={styles.socialContainer}>
                <a href={user.github} target="_blank" rel="noopener noreferrer" className={styles.socialItem}>
                    <div className={`${styles.socialItemImg} ${styles.githubIcon}`}></div>
                </a>
                <a href={user.telegram} target="_blank" rel="noopener noreferrer" className={styles.socialItem}>
                    <div className={styles.socialItemImg}>
                        <img
                            src="/social/telegram.png"
                            alt="Telegram"
                        />
                    </div>
                </a>
                <a href={`mailto:${user.email}`} className={styles.socialItem}>
                    <div className={`${styles.socialItemImg} ${styles.emailIcon}`}></div>
                </a>
                <a href={user.discord} target="_blank" rel="noopener noreferrer" className={styles.socialItem}>
                    <div className={`${styles.socialItemImg} ${styles.discordIcon}`}></div>
                </a>
            </div>
            <Toast/>
        </Layout>
    );
}